import { enClientPortalAppraiserSelectionSection } from './ValuationPlausibility/AppraiserSelectionSection'
import { enClientPortalApprovalModal } from './ValuationPlausibility/ApprovalModal'
import { enClientPortalHandoverApprovalSection } from './ValuationPlausibility/HandoverApprovalSection'
import { enClientPortalHandoverApprovalStatusActions } from './ValuationPlausibility/HandoverApprovalStatusActions'
import { enClientPortalHandoverModal } from './ValuationPlausibility/HandoverModal'
import { enClientPortalValuationPlausibilityHeaderBar } from './ValuationPlausibility/HeaderBar'
import { enClientPortalInternalApprovalModal } from './ValuationPlausibility/InternalApprovalModal'
import { enClientPortalPlausibilityAnnotations } from './ValuationPlausibility/PlausibilityAnnotations'
import { enClientPortalPlausibilityPdf } from './ValuationPlausibility/PlausibilityPdf'
import { enClientPortalValuationPlausibilityPage } from './ValuationPlausibility/ValuationPlausibility'

export const enClientPortalValuationPlausibility = {
    valuationPlausibility: enClientPortalValuationPlausibilityPage,
    headerBar: enClientPortalValuationPlausibilityHeaderBar,
    handoverApprovalSection: enClientPortalHandoverApprovalSection,
    handoverApprovalStatusActions: enClientPortalHandoverApprovalStatusActions,
    handoverModal: enClientPortalHandoverModal,
    approvalModal: enClientPortalApprovalModal,
    internalApprovalModal: enClientPortalInternalApprovalModal,
    appraiserSelectionSection: enClientPortalAppraiserSelectionSection,
    plausibilityAnnotations: enClientPortalPlausibilityAnnotations,
    plausibilityPdf: enClientPortalPlausibilityPdf,
}
